import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ReviewTypeModelComponent } from './review-type-model/review-type-model.component';
import { DeleteBoxComponent } from '../common/delete-box/delete-box.component';

@Component({
  selector: 'app-review-type-summary',
  templateUrl: './review-type-summary.component.html',
  styleUrl: './review-type-summary.component.scss'
})
export class ReviewTypeSummaryComponent {
  Statuslist: any = [];
  reviewTypeSearch: UntypedFormGroup;
  columnDefs: any[];
  tempoperations: any[];
  operations: any[];
  rowData;
  isSettings: boolean = false;
  ProgramList: any[];
  gridApi: any;
  selectedRow: any;
  collapesedOrNot: boolean = false;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.Statuslist = [
      { "value": "", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }

    ];

    this.reviewTypeSearch = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      MODULE_ID: new UntypedFormControl(""),
      SUB_MODULE: new UntypedFormControl(""),
      RECORD_STATE: new UntypedFormControl(),
      RecordStatus: new UntypedFormControl(""),
      DESCRIPTION: new UntypedFormControl(""),
    });

    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME"
      },
      {
        "headerName": "Program",
        "field": "ProgramName"
      },
       {
        "headerName": "Type",
        "field": "Type"
      },
      {
        "headerName": "Status",
        "field": "RecordStatus"
      }
    ];
    this.tempoperations = [];

    if (this.commonService.getScreenPermission("632", "V")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "View",
        "id": "View"
      });
    }

    if (this.commonService.getScreenPermission("632", "N")) {
      this.tempoperations.push({
        "name": "Add Review & Approval Title",
        "id": "Add"
      });
    }

    if (this.commonService.getScreenPermission("632", "E")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "Edit",
        "id": "Edit"
      });
    }

    if (this.commonService.getScreenPermission("632", "D")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "Delete",
        "id": "Delete"
      });
    }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.summaryService.GetMasterScreenData("api/reviewtype/GetMasterScreenData?RecordID=").subscribe(summary => {
      this.ProgramList = summary["MasterData1"];
      this.ProgramList = [{ label: "Select", value: "", checked: true }].concat(this.ProgramList);
    });
    this.GetSummary();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  Add() {
    let modalRef = this['self'].modalService.open(ReviewTypeModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "" }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }

  Edit(Record:any) {
   
    let modalRef = this['self'].modalService.open(ReviewTypeModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }


  View(Record: any) {
   
    const modelRef=this['self'].modalService.open(ReviewTypeModelComponent, {
     backdrop: false,
     keyboard: false,
     windowClass: 'modal-lg right modal-right',
     animation: true
   });
   modelRef.componentInstance.Content={
     heading: 'View',
     content: { id: Record['ID'] }
   }
 }

 Delete(Record: any) 
 {
  let id = Record['ID'];
  let name = Record['NAME'];
  let message = "";
  const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
  modalRef.componentInstance.Content={ heading: 'Delete', 
  custommessage: 'Are you sure you want to delete the Review & Approval Title   ' +"'" + name + "'" + ' ?',
   ProceedButtonName: "Delete", 
   TerminateButtonName: "Cancel" }
  modalRef.result.then(result => {
    if (result == "okclick")
      this["self"].summaryService.Delete('api/reviewtype/delete?id=' + id).subscribe(summary => {
        if (summary["Status"] == 0) {
          this["self"].commonService.SuccessBanner(summary.Message);
          this['self'].GetSummary();
        }
        else {
          this["self"].commonService.ValidationBanner(summary.Message);
        }

     });

  })

};

  GetSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData('api/reviewtype/SummaryData').subscribe(summary => {
      this.rowData = summary;
    });
  }

  SearchClear() {
    this.reviewTypeSearch.patchValue({
      NAME: "",
      RecordStatus: "",
      MODULE_ID: ""
    });
  }

  AdvanceSearch() {
    var formData = this.reviewTypeSearch.value;
    this.getSearchData(formData);
  }

  getSearchData(searchData) {
    this.summaryService.AdvanceSearch('api/reviewtype/search', searchData).subscribe(summary => {
      this.rowData = summary
    });
  }

}
